import { APICore } from 'helpers/api/apiCore'
import { APICoreWebSocket } from 'helpers/api/apiCoreWebSocket'
import {
  CadastroSimplificadoReq,
  DadosBancariosReq,
  FinalizaAgendamentoDto,
  InfoCliente,
  MatriculaReq,
  RequestValidacaoNovoAtendimentoDto,
  TabulacaoAtendimento
} from 'models/atendimento/types'
import {
  AnswersFormularioNecessidade,
  ConvenioDado,
  RdStationProps
} from 'models/types'
import { removeMaskCEP, removeMaskCPF, removeMaskMoney } from 'util/masks'

const api = new APICore()
const apiWs = new APICoreWebSocket()

export function getFormularioAtendimento30(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Atendimento/valida-cliente?cpf=${cpfFormated}`, null)
}

export function salvarFormularioAtendimento30(
  params: AnswersFormularioNecessidade
) {
  const cpfFormated = removeMaskCPF(params.cpf)
  return api.create(`FormularioAtendimento/formulario-atendimento`, {
    valorDesejado: removeMaskMoney(params.valorDesejado),
    possuiCarro: params.possuiCarro,
    carroQuitado: params.carroQuitado,
    possuiImovel: params.possuiCarro,
    imovelQuitado: params.imovelQuitado,
    pagarDividas: params.pagarDividas,
    despesasMedicas: params.despesasMedicas,
    reformas: params.reformas,
    adquirirBem: params.adquirirBem,
    emprestarFamiliarAmigo: params.emprestarFamiliarAmigo,
    investirNegocio: params.investirNegocio,
    ferias: params.ferias,
    outros: params.outros,
    observacao: params.observacao,
    cpf: cpfFormated
  })
}

export function getInformacoesSimplificadas(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Atendimento/informacoes-simplificadas`, {
    cpf: cpfFormated
  })
}

/**Tab Contato*/
export function iniciarAtendimento(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Atendimento/iniciar-atendimento`, {
    cpf: cpfFormated
  })
}

interface IniciarAtendimentoDiscadorProps {
  cpf: string
  telefoneId: string
  campanhaCrmId: string
}
export function iniciarAtendimentoCampanhaDiscador(
  params: IniciarAtendimentoDiscadorProps
) {
  const cpfFormated = removeMaskCPF(params.cpf)
  return api.create(`Atendimento/iniciar-atendimento-campanha-discador`, {
    cpf: cpfFormated,
    telefoneId: params.telefoneId,
    campanhaCrmId: params.campanhaCrmId
  })
}

export function pausarAgente(identificador: string) {
  return api.create(`IntegracaoTelecom/pausar`, {
    identificador
  })
}

export function despausarAgente() {
  return api.create(`IntegracaoTelecom/despausar`, null)
}

export function getConvenios() {
  return api.get(`Generic/convenios`, null)
}

export function getPerfis() {
  return api.get(`Generic/perfis`, null)
}

export function getProfissoes() {
  return api.get(`Generic/profissoes`, null)
}

export function salvarCadastroSimplificado(params: CadastroSimplificadoReq) {
  return api.create(`Atendimento/cadastro-simplificado`, params)
}

export function getPerfilCliente(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Generic/matriculas-by-cpf`, {
    cpf: cpfFormated
  })
}

interface discarClienteProps {
  cpf: string
  tipoLigacao: number | string
  atendimentoId: string
  telefoneId?: string
}
export function discarCliente(params: discarClienteProps) {
  return api.create(
    `IntegracaoTelecom/discar?cpfCnpj=${params.cpf}&tipoLigacao=${
      params.tipoLigacao
    }&atendimentoId=${params.atendimentoId}&telefoneId=${
      params.telefoneId ?? ''
    }`,
    null
  )
}

export function getAtendimentos(
  cpf: string,
  pagina: number,
  registros: number
) {
  return api.get(`Atendimento/chamadas`, {
    cpf: cpf,
    pagina: pagina + 1,
    registros: registros
  })
}

export function getTabulacoes() {
  return api.get(`Tabulacao/tabulacoes`, null)
}

export function getTiposAtendimento() {
  return api.get(`Generic/tipos-atendimento`, null)
}

export function tabularAtendimento(params: TabulacaoAtendimento) {
  return api.create(`Atendimento/action-tabulacao`, params)
}

export function finalizaAgendamento(value: FinalizaAgendamentoDto) {
  return api.update(`Atendimento/finaliza-agendamento`, value)
}

export function enriquecerDados(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Lemit?cpf=${cpfFormated}`, null)
}

export function validarNovoAtendimento(
  params: RequestValidacaoNovoAtendimentoDto
) {
  const dataFormatted: RequestValidacaoNovoAtendimentoDto = {
    ...params,
    cpf: removeMaskCPF(params.cpf)
  }
  return api.create(`Atendimento/valida-novo-atendimento`, dataFormatted)
}

export function getInformacoesLead(cpf: string, matricula: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Atendimento/informacoes-lead`, {
    cpf: cpfFormated,
    matricula
  })
}
export function enviarSms(phone: number, message: string, cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Kolmeya/envia-sms`, [
    {
      phone,
      message,
      cpf: cpfFormated
    }
  ])
}

export function respostaSms(telefone: number) {
  return api.get(`Kolmeya/reply-telefone`, {
    telefone
  })
}
export function mensagensRiberSMS(telefone: number) {
  return api.get(`Kolmeya/response-sms`, {
    telefone
  })
}

export function adicionarNovoTelefone(
  cpf: string,
  telefone: string,
  isWhatsApp: boolean | null
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(
    `Atendimento/adicionar-telefone?cpf=${cpfFormated}&ddd=${telefone.substring(
      1,
      3
    )}&numero=${telefone.substring(5)}&whatsapp=${isWhatsApp}`,
    null
  )
}

export function iniciarRetornoDiscagemTelecom(eventName: string) {
  return apiWs.connectToHub(`RetornoDiscagemTelecom`, eventName)
}

// /**Tab Produto*/

export function getPropostasCrm(cpf: string, numeroMatricula: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Simulacao/simulacao`, {
    cpf: cpfFormated,
    numeroMatricula
  })
}

export function getPropostasCrefaz(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Simulacao/emprestimo-crefaz`, {
    cpf: cpfFormated
  })
}

export function atualizarContatoRd(
  cpf: string,
  params: Partial<RdStationProps>
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.update(`RdStation/AtualizarContato?cpf=${cpfFormated}`, params)
}
export function EditPropostas(
  Id: string,
  numeroProposta: string,
  valorParcela: number,
  parcelasEmAberto: number,
  saldoDevedor: number
) {
  return api.update(`Operacao/proposta-portabilidade`, {
    Id,
    numeroProposta,
    valorParcela,
    parcelasEmAberto,
    saldoDevedor
  })
}

export function solicitarSimulacaoFgts(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`fgts/solicitar-simulacao/${cpfFormated}`, {
    valorSolicitado: 0,
    quantidadeParcela: 10
  })
}

export function getParcelaFgts(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`fgts/parcela/${cpfFormated}`, {
    cpf: cpfFormated
  })
}

export function recalculoProposta(
  cpf: string,
  numeroMatricula: string,
  quantidadeparcelas: number,
  valorTotalFinanciado: number,
  valorParcela: number,
  servico: number,
  codigoProduto: number,
  banco: number,
  numeroProposta: string | null,
  taxaOrigem: number | null,
  quantidadeTotalParcelas: number,
  saldoDevedor: number | null,
  codigoBanco: string | null
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.getWithoutUndefined(`Simulacao/recalculo`, {
    cpf: cpfFormated,
    numeroMatricula,
    quantidadeparcelas,
    valorTotalFinanciado,
    valorParcela,
    servico,
    codigoProduto,
    banco,
    numeroProposta,
    taxaOrigem,
    quantidadeTotalParcelas,
    saldoDevedor,
    codigoBanco
  })
}

export function recalculoSimulacaoRefinItau(
  cpf: string,
  numeroMatricula: string,
  quantidadeParcelas: number,
  valorParcela: number,
  servico: number,
  codigoProduto: number,
  banco: number,
  contrato: string,
  valorAgregacao: number
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Operacao/recalculo-simulacao-refin-itau`, {
    cpf: cpfFormated,
    numeroMatricula,
    quantidadeParcelas,
    valorParcela,
    servico,
    codigoProduto,
    banco,
    contrato,
    valorAgregacao
  })
}

export function recalculoCrefaz(
  cpf: string,
  propostaId: number,
  valor: number,
  convenioDados: ConvenioDado[]
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.update(`Simulacao/selecao-oferta-emprestimo-crefaz`, {
    cpf: cpfFormated,
    propostaId,
    valor,
    convenioDados
  })
}

export function recalculoPropostaFgts(
  cpf: string,
  valor: number,
  parcelas: number
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`fgts/solicitar-simulacao/${cpfFormated}`, {
    cpf: cpfFormated,
    valorSolicitado: valor,
    quantidadeParcela: parcelas
  })
}

export function getResumoContratacao(cpf: string, matriculas: string[]) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Contratacao/resumo-contratacao`, {
    cpf: cpfFormated,
    matriculas: matriculas
  })
}

export function getSolicitacoesIN100(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Cliente/solicitacoesIn100`, {
    cpf: cpfFormated
  })
}

export async function getDemonstrativos(cpf: string, matricula: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return await api.get(`Atendimento/demonstrativo`, {
    cpf: cpfFormated,
    matricula
  })
}
export function getTelefonesValidos(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Generic/telefones-validos`, {
    cpf: cpfFormated
  })
}

export function getTelefones(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Generic/telefones`, {
    cpf: cpfFormated
  })
}

export function getTelefonesMascara(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Generic/telefones-mascara`, {
    cpf: cpfFormated
  })
}

export function inserirSolicitacaoIN100(
  cpf: string,
  telefone: string,
  matricula: string
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(
    `Operacao/inserir-solicitacao?cpf=${cpfFormated}&ddd=${telefone.substring(
      1,
      3
    )}&telefone=${telefone.substring(5)}&matricula=${matricula}`,
    null
  )
}

export function validaStatusIN100(cpf: string, matricula: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(
    `Operacao/valida-status-in100?cpf=${cpfFormated}&numeroMatricula=${matricula}`,
    null
  )
}

export function validacaoIN100(cpf: string, token: string, matricula: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(
    `Operacao/valida-codigo-cliente?cpf=${cpfFormated}&matricula=${matricula}&token=${token}`,
    null
  )
}

export function consentimentoItau(
  cpf: string,
  telefone: string,
  canal: string,
  matricula: string
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(
    `Operacao/coleta-consentimento?cpf=${cpfFormated}&ddd=${telefone.substring(
      1,
      3
    )}&numeroTelefone=${telefone
      .replace('-', '')
      .substring(5)}&numeroMatricula=${matricula}&canal=${canal}`,
    null
  )
}

export function ConsultaConsentimentoItau(cpf: string, matricula: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(
    `Operacao/consulta-consentimento?cpf=${cpfFormated}&numeroMatricula=${matricula}`,
    null
  )
}

export function getProdutosContratados(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Operacao/propostas-pagas-cliente`, {
    cpf: cpfFormated
  })
}

export function validacaoContratacao(
  cpf: string,
  matriculas: string[],
  bancos: number[]
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Contratacao/validacao-contratacao`, {
    cpf: cpfFormated,
    matriculas,
    bancos
  })
}

export interface InfosEmprestimoBmg {
  cpf: string
  numeroMatricula: string
  quantidadeParcelas: number
  valorParcela: number
  servico: number
  numeroProduto: number
  bancoSimulacaoEnum: number
  codigoFormaEnvioTermo: string
  valorLiberado: number
  capitalSegurado?: number | null
  valorDoSeguro?: number | null
}
export function contratacaoBmg(infosEmprestimoBmg: InfosEmprestimoBmg) {
  const cpfFormated = removeMaskCPF(infosEmprestimoBmg.cpf)
  return api.create(`Contratacao/emprestimo_bmg`, {
    ...infosEmprestimoBmg,
    cpf: cpfFormated
  })
}

interface ContratacaoItauProps {
  codigoSimulacao: number
  cpf: string
  numeroMatricula: string
  quantidadeParcelas: number
  valorParcela: number
  valorLiberado: number
  servico: number
  bancoSimulacaoEnum: number
  flagRefin: boolean
  codigoPlano: number
  descricaoSeguro: string
  capitalSegurado: number
  valorDoSeguro: number
}

export function contratacaoItau({
  codigoSimulacao,
  cpf,
  numeroMatricula,
  quantidadeParcelas,
  valorParcela,
  valorLiberado,
  servico,
  bancoSimulacaoEnum,
  flagRefin,
  codigoPlano,
  descricaoSeguro,
  capitalSegurado,
  valorDoSeguro
}: ContratacaoItauProps) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Contratacao/emprestimo-itau`, {
    codigoSimulacao,
    cpf: cpfFormated,
    numeroMatricula,
    quantidadeParcelas,
    valorParcela,
    valorLiberado,
    servico,
    bancoSimulacaoEnum,
    flagRefin,
    codigoPlano,
    descricaoSeguro,
    capitalSegurado,
    valorDoSeguro
  })
}

export interface InfosContratacaoCartaoBeneficioBmg {
  cpf: string
  numeroMatricula: string
  quantidadeParcelas: number
  valorParcela: number
  valorSaque: number
  servico: number
  flagAberturaConta: boolean
  bancoSimulacaoEnum: number
  codigoPlano: number
  descricaoSeguro: string
  capitalSegurado: number
  valorDoSeguro: number
  tipoSaque: number
}
export function contratacaoCartaoBeneficioBmg(
  infosCartaoBeneficioBmg: InfosContratacaoCartaoBeneficioBmg
) {
  const cpfFormated = removeMaskCPF(infosCartaoBeneficioBmg.cpf)
  return api.create(`Contratacao/cartao-beneficio-bmg`, {
    ...infosCartaoBeneficioBmg,
    cpf: cpfFormated
  })
}

export interface InfosCartaoDeCreditoContratacao {
  cpf: string
  numeroMatricula: string
  valorSaque: number
  servico: number
  flagAberturaConta: boolean
  bancoSimulacaoEnum: number
  codigoPlano: number
  descricaoSeguro: string
  capitalSegurado: number
  valorDoSeguro: number
  tipoSaque: number
  quantidadeParcelas: number
  valorParcela: number
}
export function contratacaoCartaoCreditoConsignado(
  infosCartaoDeCredito: InfosCartaoDeCreditoContratacao
) {
  const cpfFormated = removeMaskCPF(infosCartaoDeCredito.cpf)
  return api.create(`Contratacao/cartao-credito-bmg`, {
    ...infosCartaoDeCredito,
    cpf: cpfFormated
  })
}

export interface InfosPortabilidadeContratacao {
  cpf: string
  quantidadeParcelas: number
  valorParcela: number
  servico: number
  numeroProduto: number
  bancoSimulacaoEnum: number
  codigoBanco: string
  codigoSimulacao: number
  codigoTabelaFator: string
  flagAberturaConta: boolean
  numeroContaInterna: number | null
  numeroContrato: string
  numeroMatricula: string
  numeroProdutoRefin: number
  quantidadeParcelasAberto: number
  quantidadeParcelasOriginal: number
  saldoDevedor: number
  tipoSaque: number
  valorLiberado: number
}

export function contratacaoPortabilidade(
  infosPortabilidade: InfosPortabilidadeContratacao
) {
  const cpfFormated = removeMaskCPF(infosPortabilidade.cpf)
  return api.create(`Contratacao/portabilidade`, {
    ...infosPortabilidade,
    cpf: cpfFormated
  })
}
export function contratacaoRefin(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Contratacao/refin`, {
    cpf: cpfFormated
  })
}

export interface InfosSaqueCartaoBmgContratacao {
  cpf: string
  numeroMatricula: string
  numeroContaInterna: number
  quantidadeParcelas: number
  valorParcela: number
  valorSaque: number
  flagAberturaConta: boolean
  servico: number
  bancoSimulacaoEnum: number
  tipoSaque: number
  codigoPlano: number
  descricaoSeguro: string
  capitalSegurado: number
  valorDoSeguro: number
}
export function contratacaoSaqueCartaoBmg(
  infosSaqueCartaoBmg: InfosSaqueCartaoBmgContratacao
) {
  const cpfFormated = removeMaskCPF(infosSaqueCartaoBmg.cpf)
  return api.create(`Contratacao/saque-cartao-bmg`, {
    ...infosSaqueCartaoBmg,
    cpf: cpfFormated
  })
}

interface ContratatacaoSidnapiBmgProps {
  cpf: string
  numeroMatricula: string
  servico: number
  bancoSimulacaoEnum: number
  valorParcela: number
}

export function contratatacaoSidnapiBmg({
  cpf,
  numeroMatricula,
  servico,
  bancoSimulacaoEnum,
  valorParcela
}: ContratatacaoSidnapiBmgProps) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Contratacao/seguro-sindnapi-bmg`, {
    cpf: cpfFormated,
    numeroMatricula,
    servico,
    bancoSimulacaoEnum,
    valorParcela
  })
}
interface FinalizacaoContratacaoCrmProps {
  cpf: string
  cpfAtendente?: string | null
  flagSaqueAutorizado?: boolean | null
  flagSaqueParcelado?: boolean | null
  flagAberturaConta?: boolean | null
  formaCredito?: number | null
  quantidadeParcelas: number
  valorParcela?: number
  finalidadeCredito?: number | null
  valorSaque?: number | null
  numeroProduto: number
  codigoSimulacao: number
  numeroMatricula: string
  servico: number
  bancoSimulacaoEnum: number
  numeroContaInterna?: number | null
  flagRefin?: boolean
  codigoPlano?: number | null
  descricaoSeguro?: string
  capitalSegurado?: number | null
  valorDoSeguro?: number
  tipoSaque: number
  valorLiberado: number
  codigoTabelaFator?: string | null
  numeroContrato?: string | null
  saldoDevedor?: number | null
  quantidadeParcelasAberto?: number | null
  quantidadeParcelasOriginal?: number | null
  numeroProdutoRefin?: number | null
  codigoBanco?: string | null
}

export function finalizacaoContratacaoCrm({
  cpf,
  finalidadeCredito,
  flagSaqueAutorizado,
  flagSaqueParcelado,
  formaCredito,
  quantidadeParcelas,
  valorParcela,
  servico,
  valorSaque,
  numeroProduto,
  codigoSimulacao,
  numeroMatricula,
  flagAberturaConta,
  bancoSimulacaoEnum,
  numeroContaInterna,
  flagRefin,
  codigoPlano,
  descricaoSeguro,
  capitalSegurado,
  valorDoSeguro,
  tipoSaque,
  valorLiberado,
  codigoTabelaFator,
  numeroContrato,
  saldoDevedor,
  quantidadeParcelasAberto,
  quantidadeParcelasOriginal,
  numeroProdutoRefin,
  codigoBanco
}: FinalizacaoContratacaoCrmProps) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Operacao/finalizacao-contratacao`, {
    cpf: cpfFormated,
    finalidadeCredito,
    flagSaqueAutorizado,
    flagSaqueParcelado,
    formaCredito,
    quantidadeParcelas,
    valorParcela,
    servico,
    valorSaque,
    numeroProduto,
    numeroMatricula,
    codigoSimulacao,
    flagAberturaConta,
    bancoSimulacaoEnum,
    numeroContaInterna,
    flagRefin,
    codigoPlano,
    descricaoSeguro,
    capitalSegurado,
    valorDoSeguro,
    tipoSaque,
    valorLiberado,
    codigoTabelaFator,
    numeroContrato,
    saldoDevedor,
    quantidadeParcelasAberto,
    quantidadeParcelasOriginal,
    numeroProdutoRefin,
    codigoBanco
  })
}

export interface ConvenioDadoContratacao {
  convenioDadosId: number
  descricao: string
  valor: string
}

export interface InfosCrefazContratacao {
  cpf: string
  servico: number
  propostaId: number
  tabelaJurosId: number
  valorSolicitado: number
  valorParcela: number
  quantidadeParcelas: number
  vencimento: string
  produtoId: number
  convenioId: number
  convenioDados: ConvenioDadoContratacao[]
  rendaPresumida: number
}
export function finalizacaoContratacaCrefazCrm(
  infosContratacao: InfosCrefazContratacao
) {
  const cpfFormated = removeMaskCPF(infosContratacao.cpf)
  return api.create(`Contratacao/emprestimo-crefaz`, {
    ...infosContratacao,
    cpf: cpfFormated
  })
}

export function finalizacaoContratacaoFgts(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`fgts/solicitar-proposta/${cpfFormated}`, {
    cpf: cpfFormated
  })
}

// /**Tab Informações*/

export function getInformacoesCliente(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Atendimento/informacoes-cliente`, {
    cpf: cpfFormated
  })
}

export function getGeneros() {
  return api.get(`Generic/generos`, null)
}

export function getOrgaosEmissores() {
  return api.get(`Generic/orgaos-emissores`, null)
}

export function getEstados() {
  return api.get(`Generic/estados`, null)
}

export function getEscolaridades() {
  return api.get(`Generic/escolaridades`, null)
}

export function getEstadosCivis() {
  return api.get(`Generic/estados-civis`, null)
}

export function getTiposArquivoCrefaz() {
  return api.get(`Generic/tipo-arquivos-crefaz`, null)
}

export function salvarAnexo(params: {
  cpf: string
  tipoArquivoCrefazId: string
  arquivo: File | null
}) {
  return api.createWithFile(
    `Crefaz/upload-arquivo?cpf=${params.cpf}&tipoArquivoCrefazId=${
      params.tipoArquivoCrefazId
    }&envioCrefaz=${false}`,
    { arquivo: params.arquivo }
  )
}

export function downloadAnexo(params: { cpf: string; nomeArquivo: string }) {
  return api.update(
    `Crefaz/download-arquivo?cpf=${params.cpf}&nomeArquivo=${params.nomeArquivo}`,
    null
  )
}

export function deletarAnexo(params: { cpf: string; nomeArquivo: string }) {
  return api.delete(
    `Crefaz/arquivo?cpf=${params.cpf}&nomeArquivo=${params.nomeArquivo}`
  )
}

export function getAnexos(params: {
  cpf: string
  pagina: number
  registros: number
}) {
  const cpfFormated = removeMaskCPF(params.cpf)
  return api.get(`Crefaz/arquivos`, {
    ...params,
    pagina: params.pagina + 1,
    cpf: cpfFormated
  })
}

export function getTiposConta() {
  return api.get(`Generic/tipos-conta`, null)
}

export function getBancos() {
  return api.get(`Generic/bancos-dados-bancarios`, null)
}

export function getPaises() {
  return api.get(`Generic/paises`, null)
}

export function getTemposEmprego() {
  return api.get(`Generic/tempos-emprego`, null)
}

export function getGrausReferencia() {
  return api.get(`Generic/graus-referencia`, null)
}

export function getCidades(siglaEstado?: string) {
  return api.get(`Generic/cidades`, {
    siglaEstado: siglaEstado
  })
}

export function salvarInformacoesCliente(infosCliente: InfoCliente) {
  return api.update(`Atendimento/informacoes-cliente`, infosCliente)
}

export function getDadosEndereco(cep: string) {
  const cepFormated = removeMaskCEP(cep)
  return api.get(`Generic/informacoes-endereco`, { cep: cepFormated })
}

// /**Tab Matriculas*/

export function getContratos(
  cpf: string,
  pagina: number,
  registros: number,
  numeroMatricula: string
) {
  return api.get(`Atendimento/contratos`, {
    cpf: cpf,
    pagina: pagina + 1,
    registros,
    numeroMatricula
  })
}

export function getInfosClienteConsig(cpf: string, numeroMatricula: string) {
  return api.get(`Atendimento/big-numbers`, {
    cpf: cpf,
    numeroMatricula
  })
}

export function adicionarMatricula(cpf: string, matricula: MatriculaReq) {
  return api.create(`ClienteMatricula/inserir`, {
    ...matricula,
    cpf: cpf
  })
}

export function removerMatricula(id: string) {
  return api.delete(`ClienteMatricula/deletar?id=${id}`)
}

export function verificaNaoPerturbe(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Atendimento/nao-perturbe`, {
    cpf: cpfFormated
  })
}

export function getIntegracao() {
  return api.get(`Atendimento/valida-parametro-integracao`, null)
}

/**Tab Dados Bancários*/
export function getTiposPix() {
  return api.get(`Generic/tipo-pix`, null)
}

export function getTiposContaCrefaz() {
  return api.get(`Generic/tipos-conta-crefaz`, null)
}

export function getTemposConta() {
  return api.get(`Generic/tempos-conta`, null)
}

export function getDadosBancariosCadastrados(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Atendimento/dados-bancarios`, {
    cpf: cpfFormated
  })
}

export function salvarDadosBancarios(data: DadosBancariosReq) {
  return api.update(`Atendimento/dados-bancarios`, data)
}

export function getDadoBancario(id: string) {
  return api.get(`Atendimento/dados-bancarios/${id}`, null)
}

export function deletarDadoBancario(id: string) {
  return api.delete(`Atendimento/dados-bancarios/${id}`)
}
export function getAgentesChatwoot() {
  return api.get(`ChatWoot/agentes`, null)
}
export function getConexoesChatwoot() {
  return api.get(`ChatWoot/inboxes`, null)
}
export function getAgenteSelecionado() {
  return api.get(`ChatWoot/verifica-agente-selecionado`, null)
}
interface criarMensagemChatwootProps {
  mensagem: string
  agentId: number
  inboxId: number
  cpfCliente: string
  numeroTelefone: string
}
export function criarMensagemChatwoot({
  mensagem,
  agentId,
  inboxId,
  cpfCliente,
  numeroTelefone
}: criarMensagemChatwootProps) {
  const cpfFormated = removeMaskCPF(cpfCliente)
  return api.create(`ChatWoot/criar-mensagem`, {
    mensagem,
    agentId,
    inboxId,
    cpfCliente: cpfFormated,
    numeroTelefone
  })
}

export function getPipelines() {
  return api.get(`Generic/pipelines`, null)
}

export function getEtapas(pipelineId: string) {
  return api.get(`Generic/etapas-pipeline`, {
    pipelineId
  })
}

interface AdicionarClienteKanbanProps {
  pipelineId: string
  pipelineEtapaId: string
  cpf: string
}
export function adicionarClienteKanban({
  pipelineId,
  pipelineEtapaId,
  cpf
}: AdicionarClienteKanbanProps) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.create(`Atendimento/adiciona-cliente-kanban`, {
    pipelineId,
    pipelineEtapaId,
    cpf: cpfFormated
  })
}
